import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../../components/label/screen-label/screenLabel";
import Loader from '../../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import moment from "moment";
import { displayErrorToast, isEmpty, isNull, removeSpecialCharAndChangeToPascal } from "../../../../utils/Utils";
import { subscriptionListRequest } from '../../../../redux/subscription/subscription.action'
import { APP_CONSTANTS, ROUTES } from "../../../../utils/AppConstants";
import { useNavigate, useLocation } from 'react-router-dom';

const AdminSubscriptionList = props => {
    const { subscriptionListSuccess, subscriptionListError } = useSelector(state => state.subscription)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();

    useEffect(() => {
        fetchSubscriptionList()
    }, [])

    const fetchSubscriptionList = () => {
        setLoading(true)
        const data = {
            productCode: APP_CONSTANTS.PRODUCT_NAME
        }
        dispatch(subscriptionListRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(subscriptionListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(subscriptionListError)) {
            setLoading(false)
        }
    }, [subscriptionListSuccess, subscriptionListError])

    const handleAddSubscriptionClick = () => {
        navigate(ROUTES.admin.newSubscription)
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Subscriptions' />
                {!isNull(subscriptionListSuccess) && !isEmpty(subscriptionListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Title</th>
                                <th scope="col" className="text-center">Price</th>
                                <th scope="col" className="text-center">Total Amount</th>
                                <th scope="col" className="text-center">Duration</th>
                                <th scope="col" className="text-center">Duration Type</th>
                                <th scope="col" className="text-center">Trial Subscription</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Date</th>
                                {/* <th scope="col" className="text-center">Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {subscriptionListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.title}</td>
                                    <td className="text-center">{element.currencySymbol} {element.price}</td>
                                    <td className="text-center">{element.currencySymbol} {element.finalPrice}</td>
                                    <td className="text-center">{element.duration}</td>
                                    <td className="text-center">{element.durationLabel}</td>
                                    <td className="text-center">
                                        <div className={element.isTrailSubscription === true ? 'active' : 'in-active'}>{element.isTrailSubscription === true ? 'Yes' : 'No'}</div>
                                    </td>
                                    <td className="text-center">
                                        <div className={element.isActive === true ? 'active' : 'in-active'}>{element.isActive === true ? 'Active' : 'In Active'}</div>
                                    </td>
                                    <td className="text-center">{moment(element.createdOn).utc().format('DD MMM YYYY')}</td>
                                    {/* <td className="text-center">
                                                        <div className="loc-list-button-container">
                                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Message</div></div>
                                                        </div>
                                                    </td> */}
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                <div className="vl-fab-container" onClick={() => handleAddSubscriptionClick()}>
                    <img src={require('../../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>
                {!isEmpty(subscriptionListError) && <div className="content-error">{subscriptionListError.message}</div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AdminSubscriptionList